import React from 'react'
export const guniv3_dai_usdc1_circles_color = {
  path: (
    <>
      <mask
        id="b"
        key="b"
        width="30"
        height="22"
        x="1"
        y="5"
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M1 5h30v22H1z" key="W4Q3RG-1B" />
        <path
          fillRule="evenodd"
          d="M16 24.064a9 9 0 1 1 0-16.129A9 9 0 1 1 20 25a8.963 8.963 0 0 1-4-.934Z"
          clipRule="evenodd"
          key="Q2MxygnOy3"
        />
      </mask>
      <path
        fill="url(#a)"
        d="m16 24.064.668-1.343L16 22.39l-.668.331.668 1.343Zm0-16.128-.668 1.343.668.332.668-.332L16 7.936Zm-.668 14.785A7.464 7.464 0 0 1 12 23.5v3c1.674 0 3.26-.393 4.668-1.092l-1.335-2.687ZM12 23.5A7.5 7.5 0 0 1 4.5 16h-3c0 5.799 4.701 10.5 10.5 10.5v-3ZM4.5 16A7.5 7.5 0 0 1 12 8.5v-3C6.201 5.5 1.5 10.201 1.5 16h3ZM12 8.5c1.2 0 2.33.28 3.332.779l1.335-2.687A10.463 10.463 0 0 0 12 5.5v3Zm4.668.779A7.463 7.463 0 0 1 20 8.5v-3c-1.674 0-3.26.393-4.668 1.092l1.335 2.687ZM20 8.5a7.5 7.5 0 0 1 7.5 7.5h3c0-5.799-4.701-10.5-10.5-10.5v3Zm7.5 7.5a7.5 7.5 0 0 1-7.5 7.5v3c5.799 0 10.5-4.701 10.5-10.5h-3ZM20 23.5c-1.2 0-2.33-.28-3.332-.779l-1.335 2.687c1.407.7 2.993 1.092 4.667 1.092v-3Z"
        mask="url(#b)"
        key="qQWexJXevb"
      />
      <path fill="url(#c)" d="M20 25a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" key="m53ROsi1pi" />
      <path
        fill="#fff"
        d="M18.35 22.225c0 .225-.15.3-.375.3-2.775-.9-4.725-3.45-4.725-6.45s1.95-5.55 4.725-6.45c.225-.075.375.075.375.3v.525c0 .15-.075.3-.225.375-2.175.825-3.675 2.85-3.675 5.25s1.575 4.5 3.675 5.25c.15.075.225.225.225.375v.525Z"
        key="jrp3bRMbBp"
      />
      <path
        fill="#fff"
        d="M20.6 20.35c0 .15-.15.3-.3.3h-.6c-.15 0-.3-.15-.3-.3v-.9c-1.2-.15-1.8-.825-2.025-1.8 0-.15.075-.3.225-.3h.675c.15 0 .225.075.3.225.15.525.45.975 1.425.975.75 0 1.275-.375 1.275-.975s-.3-.825-1.35-.975c-1.575-.225-2.325-.675-2.325-1.95 0-.975.75-1.725 1.8-1.875v-.9c0-.15.15-.3.3-.3h.6c.15 0 .3.15.3.3v.9c.9.15 1.5.675 1.65 1.5 0 .15-.075.3-.225.3h-.6c-.15 0-.225-.075-.3-.225-.15-.525-.525-.75-1.2-.75-.75 0-1.125.375-1.125.9s.225.825 1.35.975c1.575.225 2.325.675 2.325 1.95 0 .975-.75 1.8-1.875 2.025v.9Z"
        key="HlS3rkzaNT"
      />
      <path
        fill="#fff"
        d="M22.025 22.525c-.225.075-.375-.075-.375-.3V21.7c0-.15.075-.3.225-.375 2.175-.825 3.675-2.85 3.675-5.25s-1.575-4.5-3.675-5.25a.412.412 0 0 1-.225-.375v-.525c0-.225.15-.3.375-.3 2.7.9 4.725 3.45 4.725 6.45s-1.95 5.55-4.725 6.45Z"
        key="LTx4eBKnQY"
      />
      <circle cx="12" cy="16" r="9" fill="url(#d)" key="WyxFcd_oui" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M8.586 11.762h3.429c2.085 0 3.666 1.12 4.254 2.752h1.068v.985h-.843c.016.156.025.315.025.476V16c0 .182-.01.36-.032.535h.85v.986h-1.088c-.604 1.608-2.172 2.718-4.234 2.718H8.586V17.52H7.395v-.986h1.191V15.5H7.395v-.985h1.191v-2.752Zm.959 5.758v1.834h2.47c1.524 0 2.656-.735 3.183-1.834H9.545Zm5.947-.986H9.545V15.5h5.949c.022.163.033.33.033.5v.025c0 .174-.012.344-.035.51Zm-3.477-3.89c1.53 0 2.667.755 3.19 1.87h-5.66v-1.87h2.47Z"
        clipRule="evenodd"
        key="gdHuAXWyBU"
      />
      <defs>
        <linearGradient
          id="a"
          key="a"
          x1="3.166"
          x2="14.745"
          y1="11.95"
          y2="29.128"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7B8A" key="Ccj5CYcv3G" />
          <stop offset="1" stopColor="#FFC0A2" key="NvFaAv5SNm" />
        </linearGradient>
        <linearGradient
          id="c"
          key="c"
          x1="15.911"
          x2="25.253"
          y1="6.775"
          y2="24.683"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0666CE" key="SyU6A4peUX" />
          <stop offset="1" stopColor="#61A9F8" key="CHH4OZksVt" />
        </linearGradient>
        <linearGradient
          id="d"
          key="d"
          x1="12"
          x2="12"
          y1="4.45"
          y2="26.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A606" key="DG-_dHickt" />
          <stop offset="1" stopColor="#FBCC5F" key="jDb6rXEFXo" />
        </linearGradient>
      </defs>
    </>
  ),
  viewBox: '0 0 32 32',
}
